import React, {
  useCallback,
  useMemo,
  useRef,
  useEffect,
  useState,
  useReducer,
} from "react";
import * as Global from "../styles/Global";
import {
  ContentSection,
  FlexColumn,
  TextOnlyButton,
  FlexRow,
  LargeButton,
  LargeButtonSecondary,
  ButtonText,
  SlideUpModal,
  ModalOverlay,
  FormInputField,
  Text,
} from "../styles/Global";
import { BiRefresh } from "react-icons/bi";
import { connect, useSelector } from "react-redux";
//AG-Grid
import { AgGridReact } from "@ag-grid-community/react";
import { ServerSideRowModelModule } from "@ag-grid-enterprise/server-side-row-model";
import { MenuModule } from "@ag-grid-enterprise/menu";
import { SetFilterModule } from "@ag-grid-enterprise/set-filter";
import { SideBarModule } from "@ag-grid-enterprise/side-bar";
import { FiltersToolPanelModule } from "@ag-grid-enterprise/filter-tool-panel";
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-alpine.css";
import moment from "moment";
import Stack from "@mui/material/Stack";
import Skeleton from "@mui/material/Skeleton";
import { RowGroupingModule } from "@ag-grid-enterprise/row-grouping";
import TournamentsFilterOptions from "./TournamentsFilterOptions";
import useLocalStorage from "../CustomHooks/useLocalStorage";
import { BsFilterRight } from "react-icons/bs";
import { AiOutlineCloseCircle } from "react-icons/ai";
import FindTournamentFilterOptions from "./FindTournamentFilterOptions";
import { findTournamentFilterReducer } from "../functions/helperFunctions";
import { IoMdRemoveCircleOutline } from "react-icons/io";
import { setModal } from "../features/modals/modalSlice";
import PullToRefresh from "react-simple-pull-to-refresh";
import QuickToggle from "./QuickToggle";
import { FaMapMarkedAlt } from "react-icons/fa";
import { debounce } from "lodash";
import sprBannerAd1 from '../assets/spr-ad-1.png';
import sprBannerAd2 from '../assets/spr-ad-2.png';
import sprBannerAd3 from '../assets/spr-ad-3.png';
import { OpenUpgrade } from "./UpgradeBlurComponent";
import { allAccessUsers } from "../pages/organizer/forms/formSelectArrays";
import { toast } from "react-toastify";

const mapDispatch = { setModal };

const GridFindTournament = ({
  dataCall,
  apiURL,
  dataCallBody,
  setDataCallBody,
  columnDefs,
  rowClassRules,
  paginationPageSize,
  refreshGrid,
  isFullWidthRow,
  fullWidthCellRenderer,
  tableValue,
  search,
  setSearch,
  state,
  dispatch,
  geocodeError,
  setModal,
  isPromo,
  isClubProfile,
  clubParams,
  isPaid,
  platform,
  seasonId,
}) => {
  const modules = useMemo(
    () => [
      ServerSideRowModelModule,
      MenuModule,
      SetFilterModule,
      SideBarModule,
      FiltersToolPanelModule,
      RowGroupingModule,
    ],
    []
  );

  const isDevelopment =
    window.location.hostname.startsWith("beta") ||
    window.location.hostname.startsWith("localhost");
  const player = useSelector((state) => state.player);
  console.log("GridFindTournament isPaid: ", isPaid);
  const localFilter =
    JSON.parse(localStorage.getItem("findTournamentFilters")) || {};
  console.log("GridFindTournament localFilter: ", localFilter);
  const [upcomingFilter, setUpcomingFilter] = useLocalStorage(
    "upcoming",
    "All"
  );
  const [pastFilter, setPastFilter] = useLocalStorage("past", "All");
  const refreshFindTournamentGrid = useSelector(
    (state) => state.refresh.refreshFindTournamentGrid
  );
  const params = new URLSearchParams(window.location.search);
  const sport = new URL(window.location.href).pathname.split("/")[2];
  const account = useSelector((state) => state.organizer.accountid);
  const [promos, setPromos] = useState([]);
  const [openFilter, setOpenFilter] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [dateRange, setDateRange] = useState();
  const [format, setFormat] = useState("All");
  const [generation, setGeneration] = useState("All");
  const [lastUsedDataCallBody, setLastUsedDataCallBody] = useState({});
  const [previousLastRow, setPreviousLastRow] = useState(null);

  // Deep equality check function for dataCallBody objects
  const isDataCallBodyEqual = useCallback((obj1, obj2) => {
    if (!obj1 || !obj2) return obj1 === obj2;

    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) return false;

    for (let key of keys1) {
      if (obj1[key] !== obj2[key]) {
        console.log(
          `🔍 GridFindTournament - Difference found in field '${key}':`,
          {
            old: obj1[key],
            new: obj2[key],
          }
        );
        return false;
      }
    }

    return true;
  }, []);
  const colorFilter =
    openFilter ||
    state.showCustomDistance ||
    (state.distance !== 100 && params.get("location") !== "disabled") ||
    state.generation !== "All";
  const activeFilters =
    (!state.resetURLParams && params.get("customType")) ||
    state.showCustomDistance ||
    (state.distance !== 100 && params.get("location") !== "disabled") ||
    state.generation !== "All";
  console.log("colorFilter: ", colorFilter);
  console.log("activeFilters: ", activeFilters);
  console.log("state: ", state);

  const setCustomFilter = () => {
    console.log("setCustomFilter: ", state.distance);
    var hardcodedFilter = {
      distance: { type: "lessThanOrEqual", filter: state.distance },
      teamcreate:
        state.generation === "All"
          ? null
          : { type: "equals", filter: state.generation },
    };
    console.log("hardcodedFilter: ", hardcodedFilter);
    gridRef.current.api.setFilterModel(hardcodedFilter);
  };

  const datasource = {
    getRows(params) {
      params.request = { ...params.request, ...dataCallBody };
      console.log(
        "dataCallBody DataSource",
        JSON.stringify(dataCallBody, null, 2)
      );
      console.log("getRows params: ", params);
      setCustomFilter();
      gridRef.current.api.showLoadingOverlay();
      fetch(
        `${process.env.REACT_APP_API_BASE_URL}/apiv2/${apiURL}`,
        //` http://localhost:5001/scoreholio/us-central1/apiv2/${apiURL}`,
        {
          method: "post",
          body: JSON.stringify(params.request),
          headers: { "Content-Type": "application/json; charset=utf-8" },
        }
      )
        .then((httpResponse) => httpResponse.json())
        .then((response) => {
          //console.log(params.api.getModel().rowsToDisplay);
          console.log("gridfindtournament response: ", response);
          if (response.hasOwnProperty("promo")) {
            setPromos(response.promo);
          }
          if (response.rows.length === 0) {
            gridRef.current.api.showNoRowsOverlay();
          } else {
            gridRef.current.api.hideOverlay();
          }
          // toast.success(response.lastRow);

          // Only update title if lastRow has changed
          if (response.lastRow !== previousLastRow) {
            const titleText = `${
              tableValue === 0 ? "Upcoming" : tableValue === 1 ? "Past" : "Mine"
            } (${
              response.lastRow === 10000
                ? "10,000+"
                : response.lastRow.toLocaleString()
            })`;

            try {
              window.Android.updateTitle(titleText);
            } catch (err) {
              console.log("android fail");
            }
            try {
              window.webkit.messageHandlers.updateTitle.postMessage(titleText);
            } catch (err) {
              console.log("webkit fail");
            }

            // Update the previous lastRow value
            setPreviousLastRow(response.lastRow);
          }
          params.successCallback(response.rows, response.lastRow);
        })
        .catch((error) => {
          console.error("dataSource error: ", error);
          params.failCallback();
        });
    },
  };

  console.log("GridFindTournament state: ", state);
  console.log("GridFindTournament promos: ", promos);

  const rowHeight = 115;
  const gridRef = useRef();
  const defaultColDefFallback = useMemo(() => {
    return {
      resizable: true,
      wrapText: true,
      autoHeight: true,
      suppressMenu: true,
    };
  }, []);
  const sideBar = useMemo(() => {
    return {
      toolPanels: [
        {
          id: "filters",
          labelDefault: "Filters",
          labelKey: "filters",
          iconKey: "filter",
          toolPanel: "agFiltersToolPanel",
        },
      ],
      defaultToolPanel: "",
    };
  }, []);

  const onGridReady = (params) => {
    console.log(
      "running GridFindTournament useEffect dataCallBody: ",
      dataCallBody
    );
    console.log(
      "running GridFindTournament useEffect lastUsedDataCallBody: ",
      lastUsedDataCallBody
    );

    console.log("onGridReady...");
    if (!isDataCallBodyEqual(dataCallBody, lastUsedDataCallBody)) {
      console.log(
        "🔥 GridFindTournament - DataCallBody changed, updating datasource"
      );
      setLastUsedDataCallBody(dataCallBody);
      if (
        !isClubProfile ||
        (isClubProfile && dataCallBody.hasOwnProperty("playerID"))
      ) {
        console.log("running onGridReady update inside isClubProfile check...");
        gridRef.current.api.setServerSideDatasource(datasource);
      }
    } else {
      console.log(
        "✅ GridFindTournament - No dataCallBody changes detected, skipping update"
      );
    }
  };

  // const onGridReady = useRef(
  //   debounce((params) => {
  //     console.log(
  //       "running GridFindTournament useEffect dataCallBody: ",
  //       dataCallBody
  //     );
  //     console.log(
  //       "running GridFindTournament useEffect lastUsedDataCallBody: ",
  //       lastUsedDataCallBody
  //     );
  //     setLastUsedDataCallBody(dataCallBody);
  //     console.log("onGridReady...");
  //     if (JSON.stringify(dataCallBody) !== JSON.stringify(lastUsedDataCallBody)) {
  //       console.log("running onGridReady update...");
  //       if (
  //         !isClubProfile ||
  //         (isClubProfile && dataCallBody.hasOwnProperty("customID"))
  //       ) {
  //         console.log("running onGridReady update inside isClubProfile check...");
  //         gridRef.current.api.setServerSideDatasource(datasource);
  //       }
  //     }
  //   }, 1000) // Adjust the debounce delay as needed
  // ).current;

  console.log("refreshFindTournamentGrid: ", refreshFindTournamentGrid);

  useEffect(() => {
    console.log("running GridFindTournament useEffect: ");
    if (gridRef.current.api) {
      console.log("running GridFindTournament onGridReady: ", dataCallBody);
      onGridReady();
    }
  }, [dataCallBody, refreshFindTournamentGrid]);

  const onRowClicked = useCallback((event) => {
    const selectedRow = event.data;
    console.log("selectedRow: ", selectedRow);
    //do stuff with selectedRow
    setModal({
      playerModals: {
        showModal: true,
        modalType: 31,
        data: { ...event.data, state, isClubProfile },
      },
    });
  }, []);

  const onFirstDataRendered = useCallback((params) => {
    gridRef.current.api.sizeColumnsToFit();
  }, []);

  const refreshCache = useCallback((route) => {
    gridRef.current.api.refreshServerSide({
      purge: true,
    });
  }, []);

  async function handleRefresh() {
    await refreshCache();
  }

  // useEffect(() => {
  //   if (gridRef.current.api) {
  //     console.log("useEffect state: ", state);
  //     setCustomFilter();
  //   }
  // }, [state, gridRef]);

  const clearFilters = useCallback(() => {
    gridRef.current.api.setFilterModel(null);
  }, []);

  //console.log("GridFindTournament refreshGrid: ", refreshGrid);
  useEffect(() => {
    //console.log("RUNNING USEEFFECT GridFindTournament:");
    if (refreshGrid > 0) refreshCache();
  }, [refreshGrid]);

  const getRowHeight = useCallback(function (params) {
    // return 100px height for full width rows
    return rowHeight ? rowHeight : 95;
  }, []);

  const Pill = ({ action, title }) => {
    return (
      <div
        className={`filterPill ${action.type}`}
        style={{
          cursor: "pointer",
          // padding: "1px 3px",
          padding: "2px 4px",
        }}
        onClick={() => dispatch(action)}
      >
        <Text size="1em" color="red" style={{ whiteSpace: "nowrap" }}>
          {title}
        </Text>
        <IoMdRemoveCircleOutline
          size={17}
          color={Global.red}
          style={{
            padding: 2,
            marginLeft: 2,
            backgroundColor: "transparent",
          }}
        />
      </div>
    );
  };

  const today = new Date();
  const sixMonthsFuture = new Date(
    new Date().setMonth(new Date().getMonth() + 6)
  ).setHours(0, 0, 0, 0);
  const fiveYearsPast = new Date(
    new Date().setFullYear(new Date().getFullYear() - 5)
  ).setHours(0, 0, 0, 0);
  console.log("today: ", today);
  console.log("sixMonthsFuture: ", sixMonthsFuture);
  console.log("fiveYearsPast: ", fiveYearsPast);
  console.log(
    "pre subtract: ",
    new Date(new Date(state.dateEnd).setMonth(new Date().getMonth() + 6))
  );
  console.log(
    "subtract: ",
    sixMonthsFuture -
      new Date(new Date(state.dateEnd).setMonth(new Date().getMonth() + 6)) !==
      0
  );

  console.log(
    "pre subtract fiveYearsPast: ",

    new Date(
      new Date(state.dateStart).setFullYear(new Date().getFullYear() - 5)
    ).setHours(0, 0, 0, 0)
  );
  console.log("new Date(fiveYearsPast): ", fiveYearsPast);
  console.log(
    "subtract fiveYearsPast: ",
    fiveYearsPast -
      new Date(
        new Date(state.dateStart).setFullYear(new Date().getFullYear() - 5)
      ).setHours(0, 0, 0, 0) !==
      0
  );

  const adBanner = useMemo(() => {
    const banners = [sprBannerAd1, sprBannerAd2, sprBannerAd3];
    return banners[Math.floor(Math.random() * banners.length)];
  }, []); // Empty dependency array means this only runs once on mount

  return (
    <div style={{ height: "100%", width: "100%" }} className="ag-theme-alpine">
      {isPromo && (
        <img
          src={localFilter.promoImage}
          alt="promo banner"
          style={{
            width: "calc(100% - 12px)",
            margin: "0 6px 5px",
            borderRadius: 10,
          }}
        />
      )}
      <FlexRow
        justify="space-between"
        align="center"
        style={{ flex: 0, padding: "5px 10px 0 0" }}
      >
        <div
          className="inputField"
          style={{
            marginLeft: 10,
            flex: 1,
            position: "relative",
          }}
        >
          <FormInputField
            id="outlined-basic"
            label="Search"
            variant="outlined"
            value={search}
            fullWidth
            margin="dense"
            onChange={(e) => setSearch(e.target.value)}
            style={{ padding: 0 }}
            size="small"
          />
          {searchValue !== "" && (
            <AiOutlineCloseCircle
              size={20}
              color={Global.blueLight}
              style={{
                position: "absolute",
                zIndex: 100,
                right: 10,
                top: "50%",
                transform: `translateY(-50%)`,
                backgroundColor: "#fff",
                borderRadius: 20,
                cursor: "pointer",
              }}
              // onClick={() => customFilter("", "search", null)}
            />
          )}
        </div>
        <BiRefresh
          size={30}
          color={Global.blueLight}
          style={{
            padding: 2,
            marginTop: 5,
            marginLeft: 5,
            marginRight: 5,
            backgroundColor: "transparent",
            borderRadius: 20,
            cursor: "pointer",
          }}
          onClick={refreshCache}
        />

        {!isClubProfile && tableValue !== 2 && (
          <div
            className="filterPill"
            style={{
              cursor: "pointer",
              borderColor: colorFilter ? Global.red : Global.blueLight,
              padding: "2px 4px",
              marginTop: 10,
            }}
            onClick={() => setOpenFilter(!openFilter)}
          >
            <BsFilterRight
              size={17}
              color={colorFilter ? Global.red : Global.blueLight}
              style={{
                padding: 2,
                // marginTop: 5,
                marginRight: 2,
                backgroundColor: "transparent",
                borderRadius: 20,
                cursor: "pointer",
              }}
            />
            <Text
              color={colorFilter ? Global.red : Global.blueLight}
              style={{
                fontWeight: "700",
              }}
              size="1em"
            >
              Filter
            </Text>
          </div>
        )}
        {!isClubProfile && (
          <div
            className="filterPill"
            style={{
              cursor: "pointer",
              borderColor: Global.red,
              padding: "2px 4px",
              marginTop: 10,
            }}
            onClick={() =>
              setModal({
                globalModals: {
                  showModal: true,
                  modalType: 37,
                  data: { state, seasonId },
                },
              })
            }
          >
            <FaMapMarkedAlt
              size={17}
              color={Global.red}
              style={{
                padding: 2,
                // marginTop: 5,
                marginRight: 2,
                backgroundColor: "transparent",
                borderRadius: 20,
                cursor: "pointer",
              }}
            />
            <Text
              color={Global.red}
              style={{
                fontWeight: "700",
              }}
              size="1em"
            >
              Map
            </Text>
          </div>
        )}
      </FlexRow>

      {!isClubProfile && !isPromo && tableValue !== 2 && (
        <FlexRow
          align="center"
          style={{
            overflowX: "auto",
            // flexWrap: "wrap",
            marginTop: 5,
            paddingLeft: 15,
          }}
        >
          {((tableValue === 0 &&
            new Date(state.dateStart).setHours(0, 0, 0, 0) >
              new Date().setHours(0, 0, 0, 0)) ||
            (tableValue === 1 &&
              fiveYearsPast -
                new Date(
                  new Date(state.dateStart).setFullYear(
                    new Date().getFullYear() - 5
                  )
                ).setHours(0, 0, 0, 0) !==
                0)) && (
            <Pill
              action={{
                type: "date_start",
                dateStart:
                  tableValue === 0
                    ? new Date().toISOString()
                    : new Date(
                        new Date().setFullYear(new Date().getFullYear() - 5)
                      ).toISOString(),
              }}
              title={`Start: ${moment(state.dateStart).format("M/D/YY")}`}
            />
          )}
          {((tableValue === 0 &&
            sixMonthsFuture -
              new Date(
                // new Date(state.dateEnd).setMonth(new Date().getMonth() + 6)
                state.dateEnd
              ).setHours(0, 0, 0, 0) !==
              0) ||
            (tableValue === 1 &&
              new Date(state.dateEnd).setHours(0, 0, 0, 0) <
                new Date().setHours(0, 0, 0, 0))) && (
            <Pill
              action={{
                type: "date_end",
                dateEnd:
                  tableValue === 0
                    ? new Date(
                        new Date().setMonth(new Date().getMonth() + 6)
                      ).toDateString()
                    : new Date().toISOString(),
              }}
              title={`End: ${moment(state.dateEnd).format("M/D/YY")}`}
            />
          )}

          {state.showCustomDistance && (
            <Pill
              action={{
                type: "show_custom_distance",
                showCustomDistance: false,
              }}
              title="Manual Location"
            />
          )}
          {state.distance !== 100 && (
            <Pill
              action={{
                type: "distance",
                distance: 100,
              }}
              title={
                state.distance === 10000
                  ? "Distance: All"
                  : `Distance: ${state.distance}mi`
              }
            />
          )}
          {sport === "cornhole" &&
            state.generation &&
            state.generation !== "All" && (
              <Pill
                action={{
                  type: "generation",
                  generation: "All",
                }}
                title={state.generation}
              />
            )}
          {activeFilters && (
            <Pill
              action={{
                type: "clearFilters",
              }}
              title={"Clear Filters"}
            />
          )}
        </FlexRow>
      )}
      <FlexColumn
        className={`filterSection ${
          (tableValue === 2 || openFilter) && "showFilterSection"
        }`}
      >
        <FindTournamentFilterOptions
          openFilter={openFilter}
          setOpenFilter={setOpenFilter}
          state={state}
          dispatch={dispatch}
          sport={sport}
          tableValue={tableValue}
          geocodeError
          isClubProfile={isClubProfile}
        />
      </FlexColumn>
      {!isPromo && promos && promos.length < 1 && !isPaid ? (
        // isDevelopment
        <img
          src={adBanner}
          onError={(e) => {
            console.log("locationimage error: ", e);
          }}
          alt="location"
          style={{
            display: "flex",
            width: "calc(100% - 12px)",
            maxWidth: "100%",
            margin: "10px 6px 5px",
            borderRadius: 10,
          }}
          onClick={() => OpenUpgrade(platform, "findTournament")}
        />
      ) : !isPromo && promos && promos.length > 0 && tableValue === 0 ? (
        <img
          src={promos[0].promoImage}
          onError={(e) => {
            console.log("locationimage error: ", e);
            // setHideImage(true);
          }}
          alt="location"
          style={{
            display: "flex",
            width: "calc(100% - 12px)",
            maxWidth: "100%",
            margin: "10px 6px 5px",
            borderRadius: 10,
          }}
          onClick={() =>
            setModal({
              playerModals: {
                showModal: true,
                modalType: 36,
                data: { promo: promos[0], state },
              },
            })
          }
        />
      ) : null}
      <PullToRefresh onRefresh={handleRefresh}>
        <AgGridReact
          className="findTournamentGrid noBorder"
          getRowId={(params) => params.data.gameid}
          suppressServerSideInfiniteScroll={false}
          rowModelType="serverSide"
          pagination="true"
          paginationPageSize={paginationPageSize ? paginationPageSize : "10"}
          cacheBlockSize={paginationPageSize ? paginationPageSize : "10"}
          suppressMovableColumns="true"
          modules={modules}
          ref={gridRef}
          columnDefs={columnDefs}
          defaultColDef={defaultColDefFallback}
          rowClassRules={rowClassRules}
          rowSelection="single"
          onFirstDataRendered={onFirstDataRendered}
          onGridReady={onGridReady}
          domLayout="autoHeight"
          suppressCellFocus={true}
          //   sideBar={sideBar}
          onRowClicked={onRowClicked}
          headerHeight={0}
          isFullWidthRow={isFullWidthRow}
          fullWidthCellRenderer={fullWidthCellRenderer}
          getRowHeight={getRowHeight}
          overlayNoRowsTemplate={
            tableValue === 2
              ? `<FlexColumn style="margin-top: -50px; width: 100%; text-align: center; padding: 10px;">
          <Text style="font-size: 1.2em; margin-bottom: 10px;">No Events Found.</Text>
          <Text style="font-size: 1.2em; width: 100%; display: flex; padding-top: 10px"> Make sure at least one of "Player", "Organizer", or "Favorites" is selected above.</Text>
          </FlexColumn>`
              : `<FlexColumn style="margin-top: -50px; width: 100%; text-align: center; padding: 10px;">
          <Text style="font-size: 1.2em; margin-bottom: 10px;">No Events Found.</Text>
          </FlexColumn>`
          }
          overlayLoadingTemplate="<span><img height='50' src='https://app.scoreholio.com/img/loading400.gif'/></span>"
        />
      </PullToRefresh>
    </div>
  );
};

export default connect(null, mapDispatch)(GridFindTournament);
